"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_REFERENCE_VALUE = void 0;
exports.chartYAxisScale = chartYAxisScale;
exports.chartMatrixScale = chartMatrixScale;
const BASE_DOMAIN = {
    z: [-2, 2.5],
    gpfit: [1, 9],
};
const TICK_STEP = { z: 0.5, gpfit: 1 };
/** Reference line of the means: z = 0, GPfit = 5 (middle of the STA9 scale). */
exports.CHART_REFERENCE_VALUE = {
    z: 0,
    gpfit: 5,
};
/**
 * Fixed y-axis (z: -2.0..2.5 in 0.5 steps, GPfit: 1..9), extended to the next
 * tick only when data lies outside.
 */
function chartYAxisScale(metric, values) {
    const step = TICK_STEP[metric];
    let [min, max] = BASE_DOMAIN[metric];
    for (const v of values) {
        if (v === null || v === undefined || !Number.isFinite(v))
            continue;
        if (v < min)
            min = Math.floor(v / step) * step;
        if (v > max)
            max = Math.ceil(v / step) * step;
    }
    const ticks = [];
    // Integer loop avoids floating point drift (e.g. 0.30000000000000004).
    const count = Math.round((max - min) / step);
    for (let i = 0; i <= count; i++)
        ticks.push(min + i * step);
    return { domain: [min, max], ticks };
}
/**
 * Compact school matrix: symmetric domain around the reference line (z 0,
 * GPfit 5), wide enough for the largest deviation of ALL schools (rounded up
 * to 0.5 z / 1 GPfit point, at least one step), so small differences stay
 * visible and every school uses the same scale.
 */
function chartMatrixScale(metric, values) {
    const ref = exports.CHART_REFERENCE_VALUE[metric];
    const step = TICK_STEP[metric];
    let dev = 0;
    for (const v of values) {
        if (v === null || v === undefined || !Number.isFinite(v))
            continue;
        dev = Math.max(dev, Math.abs(v - ref));
    }
    const half = Math.max(step, Math.ceil(dev / step - 1e-9) * step);
    return {
        domain: [ref - half, ref + half],
        ticks: [ref - half, ref, ref + half],
    };
}
